import React = require('react');
import { DialogType } from '@tableau/widgets';

import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Set } from '~commonInfra/utils/Set';

import { Formatters, Messages } from '../../../../codegen/Localize';
import { ModalInstance, ReactModalService } from '../../../../commonInfra/dialogs/ReactModalService';
import { L10n } from '../../../../commonInfra/L10n/L10n';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { ResultHelper } from '../../../../httpClient/utils/ResultHelper';
import { SiteRoleOptionsResource } from '../../../services/resources/SiteRoleOptions';
import { UpdateGrantLicenseModeDialog } from '../../components/UpdateGrantLicenseModeDialog';
import { Groups } from '../../Groups';
import { IGroupDetailsInfo } from '../../models/IGroupDetailsInfo';
import { IGroupBasicInfo, IGroupInfo } from '../../models/IGroupInfo';
import { GrantLicenseModes } from '../../serverApi/requests/SyncActiveDirectoryGroupRequest';

const groupUpdateDialogStyle: React.CSSProperties = {
    width: 'auto',
    height: 'auto',
    paddingTop: '18px',
    paddingBottom: '12px',
    paddingLeft: '12px',
    paddingRight: '12px'
};

function executeInPlace(group: IGroupDetailsInfo, siteRole: string, grantLicenseMode: GrantLicenseModes) {
    const groupSet = Set.fromIdItemArray([group]);
    return Groups.updateGroupsMinimumSiteRole([group.id], siteRole, grantLicenseMode)
        .then(ResultHelper.rejectResultOnError())
        .then(() => handleSuccessResult(groupSet, siteRole))
        .catch((result: IResult) => handleErrorResult(groupSet, siteRole, result));
}

function showUpdateGroupsMinimumSiteRoleDialog(groupsToSet: Set<IGroupInfo>): Promise<any> {
    let modalInstance: ModalInstance;

    const dialogProps = {
      dismiss: () => modalInstance && modalInstance.dismiss('cancel'),
      close: (result: any) => modalInstance && modalInstance.close(result),
      groupsToSet: groupsToSet,
      isActiveDirectory: true
    };

    modalInstance = ReactModalService.open({
      type: DialogType.Uber,
      dialogContent: React.createElement(UpdateGrantLicenseModeDialog, dialogProps),
      testId: 'updateLocalGroupGrantLicenseMode',
      showCloseButton: true,
      dialogStyle: groupUpdateDialogStyle,
      shouldNotSetDefaultWidth: false
    });

    return Promise.resolve(modalInstance.result);
}

function handleSuccessResult(groups: Set<IGroupBasicInfo>, siteRole: string) {
    ToasterService.instance.pop({
        type: ToastType.Info,
        text: Messages.updateGroupsSiteRoleSettingsSuccess({
            GROUP_NAME: L10n.elideIfLong(groups.first().name),
            COUNT: groups.size(),
            COUNT_LOC: Formatters.formatCount(groups.size())
        })
    });
}

function handleErrorResult(groups: Set<IGroupBasicInfo>, siteRole: string, result: IResult) {
    ToasterService.instance.pop({
        type: ToastType.Error,
        text: Messages.updateGroupsMinimumSiteRoleError({
            GROUP_NAME: L10n.elideIfLong(groups.first().name),
            COUNT: groups.size(),
            SITE_ROLE: SiteRoleOptionsResource.instance.getSiteRoleName(siteRole)(),
            COUNT_LOC: Formatters.formatCount(groups.size())
        })
    });
    return Promise.reject(result);
}

export const UpdateGroupsMinimumSiteRoleAction = {
    executeInPlace,
    showUpdateGroupsMinimumSiteRoleDialog
};

export type UpdateGroupsMinimumSiteRoleAction = typeof UpdateGroupsMinimumSiteRoleAction;
